import TableSkeletonComponent from "@/app/components/ui/LoaderComponent";
import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";

import { useAppoitmentStatusList } from "@/app/hooks/api_hooks/dayClosing/useAppoitmentStatusList";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import { useLoader } from "@/app/hooks/useLoader";
import { useUtils } from "@/app/hooks/useUtils";
import clsx from "clsx";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const GRNClosureComponent = () => {
  const { veticDateFormat, POStatusTextColor, convertToReadableFormat } = useUtils();

  const { execute: fetchDayClosingData, closureData } = useAppoitmentStatusList();
  const queryParams = new URLSearchParams(location.search);
  const isLoading = useLoader("isClosingDataInProgress");
  const { NO_APPOINTMENTS } = useImageConstants();
  const navigate = useNavigate();

  // ✅ read query params

  const queryCity = queryParams.get("city_id");
  const queryClinics = queryParams.get("clinic_ids");
  const queryShift = queryParams.get("shift") ?? "day";
  const time = queryParams.get("t") ?? "";

  useEffect(() => {
    if (queryClinics && queryClinics) {
      fetchDayClosingData(queryClinics, queryShift, "operations", "grn");
    }
  }, [queryCity, queryClinics, queryShift, time]);
  const clinicsWithGrn = closureData?.filter((clinic) => clinic?.closure_list?.length > 0) || [];

  const handleAction = (item: any) => {
    if (item?.transfer_order) {
      window.open(`/app/inventory/transfer-order-details/${item?.po_id}`, "_blank");
      return;
    }
    window.open(`/app/inventory/purchase-add?po_id=${item?.po_id}`, "_blank");
  };

  return (
    <div className="w-full">
      {isLoading ? (
        <TableSkeletonComponent columnLength={8} />
      ) : clinicsWithGrn.length > 0 ? (
        <>
          {clinicsWithGrn.map((clinic, clinicIndex) => (
            <div
              key={clinic?.clinic_id || clinicIndex}
              className="mb-4 rounded-2xl border border-[#ECEEF2] bg-white p-3 shadow-sm"
            >
              <div className="overflow-x-auto rounded-xl">
                <table className="w-full min-w-[980px] border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
                  <thead className="bg-[#F5F5F5] text-[#1F1F23] text-xs font-normal">
                    <tr>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Vendor Name</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">PO ID</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">PO-Status</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Created By</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="text-xs">
                    {clinic.closure_list.map((item, rowIndex) => {
                      const isFirst = rowIndex === 0;
                      const isLast = rowIndex === clinic.closure_list.length - 1;
                      const isSingle = clinic.closure_list.length === 1;

                      return (
                      <tr
                        key={item?.po_id || rowIndex}
                        className={`
                          bg-white hover:bg-[#FCFCFD] transition-colors
                          ${isSingle ? "rounded-xl" : ""}
                          ${isFirst && !isSingle ? "rounded-t-xl" : ""}
                          ${isLast && !isSingle ? "rounded-b-xl" : ""}
                        `}
                      >
                        <td
                          className={`
                            p-3 text-xs whitespace-nowrap
                            ${isSingle ? "rounded-tl-2xl rounded-bl-2xl" : ""}
                            ${isFirst && !isSingle ? "rounded-tl-2xl" : ""}
                            ${isLast && !isSingle ? "rounded-bl-2xl" : ""}
                          `}
                        >
                          {item.primary_purchase_info?.vendor_details?.vendor_name}
                        </td>
                        <td className="p-3 text-xs whitespace-nowrap">{item.po_number}</td>
                        <td className="p-3 text-xs">
                          <div className="w-[180px]">
                            <div
                              className={clsx(
                                "flex justify-center items-center p-1 rounded-full text-black text-[10px] sm:text-xs w-auto text-center",
                                POStatusTextColor(item?.po_status, true),
                              )}
                            >
                              {convertToReadableFormat(item?.po_status)}
                            </div>
                          </div>
                        </td>
                        <td className="p-3 text-xs">
                          <p>{item?.created_by}</p>
                          {veticDateFormat(item.created_at)}
                        </td>
                        <td
                          className={`
                            p-3 text-xs w-[130px]
                            ${isSingle ? "rounded-tr-2xl rounded-br-2xl" : ""}
                            ${isFirst && !isSingle ? "rounded-tr-2xl" : ""}
                            ${isLast && !isSingle ? "rounded-br-2xl" : ""}
                          `}
                        >
                          <button
                            className="bg-black px-5 py-2 rounded-lg text-[10px] sm:text-xs text-white font-medium whitespace-nowrap hover:opacity-90 transition-opacity"
                            onClick={() => handleAction(item)}
                          >
                            {item?.transfer_order ? "Go to TO" : "Go to PO"}
                          </button>
                        </td>
                      </tr>
                    );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </>
      ) : (
        <NoDataFoundComponent imageURL={NO_APPOINTMENTS} message="No GRN records found" />
      )}
    </div>
  );
};

export default GRNClosureComponent;
